export function accordionToggle () {
  const accordionElement = document.querySelector('.pep-ea-accordion')

  if (accordionElement) {
    const accordionToggle = document.querySelectorAll('[data-toggle-accordion]')
    const onlyOneActive = accordionElement.dataset.onlyOneActive

    accordionToggle.forEach(accordionButton => {
      accordionButton.addEventListener('click', () => {
        const isExpanded = accordionButton.getAttribute('aria-expanded')
        const accordionItem = accordionButton.closest('.pep-ea-accordion-item')
        const accordionBody = accordionItem.querySelector('.pep-ea-accordion-item__body')

        if (onlyOneActive === 'true') {
          toggleAllAccordionItems(accordionElement, accordionButton, accordionBody, isExpanded)
        }
        else {
          toggleSingleAccordionItem(accordionItem, accordionButton, accordionBody, isExpanded)
        }
      })
    })
  }

  function toggleSingleAccordionItem (accordionItem, accordionButton, accordionBody, isExpanded) {
    if (isExpanded === 'true') {
      accordionButton.setAttribute('aria-expanded', 'false')
      accordionBody.setAttribute('aria-hidden', 'true')
      accordionItem.classList.remove('active')
    }
    else {
      accordionButton.setAttribute('aria-expanded', 'true')
      accordionBody.setAttribute('aria-hidden', 'false')
      accordionItem.classList.add('active')
    }
  }

  function toggleAllAccordionItems (accordionElement, accordionButton, accordionBody, isExpanded) {
    const accordionItems = accordionElement.querySelectorAll('.pep-ea-accordion-item')
    const accordionItem = accordionButton.closest('.pep-ea-accordion-item')

    // collapse all accordion items
    accordionItems.forEach(accordionItem => {
      const button = accordionItem.querySelector('[data-toggle-accordion]')
      const body = accordionItem.querySelector('[aria-hidden]')

      accordionItem.classList.remove('active')
      button.setAttribute('aria-expanded', 'false')
      body.setAttribute('aria-hidden', 'true')
    })

    // // open clicked accordion item
    toggleSingleAccordionItem(accordionItem, accordionButton, accordionBody, isExpanded)
  }
}
